import $ from 'jquery';
import breaky from 'breaky';
import Keyboard from './keyboard';
import customPaging from './slick/custom-paging';
import 'jquery-doubletaptogo';
import 'jquery-mask-plugin';
import './slick-carousel';
import './modal';
import './grid-span-sizer';
import './enabled-button';
import './accordion';
import './countdown';
import './enterable';
import './fixed-header';
import './dropdown';
import './progress-ring';
import './dropdown-enter';
import './track-video';
import './sticky-video';
import './slick-slider';
import './increment-count';
import './focus-to';
import './close-banner';
import './toggle-text';
import './toggle-elements';
import './toggle-display';
import './jump-container';
import './product-zoom';
import './toggle-row';
import './mask-date';
import './toggle-change';
import './toggle-reveal';
import './switch-class';
import './drawer';
import './sticky-scroll';
import './rating-scale/rating-scale';
import './copy-clipboard';
import './tooltip';
import './recs-pop-out'
import './has-mouse-event';
import './fixed-corner';
import './scroll-to-top';
import './trim-total';
import './tabs';
import './product-swatches';
import './sticky-nav';
import './fixed-sidebar';
import './cc-mask';
import './ab-controls';
import './impressions-controls';
import './lazy-ajax';
import './progressiveButton';
import './add-to-calendar';
import './counter';
import noFocus from './no-focus';
import './header';
import './gwp-responsive-slider';
import './product-filter-active-button';
import './slides';
import './abtest/follow-shops';
import './image-upload';
import './shop-the-look';
import './abtest/custom-video-player';
import './abtest/floating-video';
import './breakpoint-layout-switch';
import './abtest/plp-left-nav-filter-redesign-ab726';
import './responsive-placeholder';
import throttle from 'lodash/throttle';
import '../abtests/ab795';
import '../abtests/ab553';

$(document).ready(() => {
  noFocus();

  $('.js-enabled-button').enabledButton();
  $('.js-beauty-add-on').recsPopOut();

  $('.js-custom-video-player').customVideoPlayer();

  $('.js-beauty-add-on-full').slickSlider({
    slidesToScroll: 6,
    slidesToShow: 6,
    lazyLoad: 'ondemand',
    responsive: [
      {
        breakpoint: 899,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4,
        }
      },
      {
        breakpoint: 1027,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 5,
        }
      }]
  });

  $('.js-buy-again-add-on').slickSlider({
    responsive: [
      {
        breakpoint: 899,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        }
      },
      {
        breakpoint: 1027,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4,
        }
      }]
  });
  $('.js-carousel--ambassador').slickSlider({
    slidesToShow: 7,
    slidesToScroll: 7,
    customPaging,
    dots: true,
    appendDots: $(".image-carousel__dots-container--centered"),
    responsive: [
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 5,
        }
      },
    ]
  })
  $('.js-carousel--ambassador-users').slickSlider({
    slidesToShow: 5,
    slidesToScroll: 5,
    dots: true,
    customPaging: (slick, i) => customPaging(slick, i, true), // Set true to show numbers
    appendDots: $(".image-carousel__indicators"),
    responsive: [
      {
        breakpoint: 1256,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4,
        }
      },
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        }
      },
    ]
  });
  $('.js-fixed-sidebar').fixedSidebar();
  $('.js-sticky-nav').stickyNav();
  $('.js-switch-class').switchClass();

  // drawer animation of dynamic content in buy now modal on PDP
  $('.js-counter').counters();
  $('.js-drawer').drawer();
  // $('.js-lazy-ajax').lazyAjax(); - not in use - see demo for usecases - /r/r_src/main/styleguide/site/lazy-ajax-demo.html
  $('.js-toggle-text').toggleText();
  $('.js-toggle-elements').toggleElements();
  $('.js-toggle-row').toggleRow();
  $('.js-focus-to').focusTo();
  $('.js-jump-container').jumpContainer();
  $('.js-tooltip').tooltip();
  $('.js-progress-ring').progressRing();
  $('.js-track-video').trackVideo();
  $('.js-order-hist-total').trimTotal();
  $('.js-mask-cc').ccMask();
  $('.js-copy-clipboard').copyToClipboard();
  $('.js-toggle-change').toggleChange();
  $(".js-toggle-display").toggleDisplay();
  $('.js-progressive-button').progressiveButton();
  $('.js-add-to-calendar').addToCalendar();
  // $('.js-single-cc').singleCC();
  $('.js-upload-form').imageUploader();
  $('.js-carousel-live').slickSlider({
    responsive: [
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4,
          infinite: false
        }
      }
    ]
  });
  $('.js-carousel--loyalty').slickSlider({
      slidesToShow: 4,
      slidesToScroll: 4,
      responsive: [
          {
              breakpoint: 821,
              settings: {
                  slidesToShow: 3,
                  slidesToScroll: 3,
              }
          }
      ]
  });
  $('.js-carousel__mix-match').slickSlider({
    infinite: true,
    nextArrow: ".carousel__nav-next",
    prevArrow: ".carousel__nav-prev",
    dots: true,
    accessiblePaging: true,
    dotsClass: "image-carousel__dots",
    appendDots: $(".image-carousel__dots-container"),
    slidesToShow: 1,
    slidesToScroll: 1,
  });

  $('.js-carousel-ctl-more').slickSlider();
  $('.js-carousel-oh-recs').slickSlider({
    slidesToShow: 6,
    slidesToScroll: 6,
    responsive: [
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4,
        }
      }
    ]
  });

  $('.js-carousel').slickSlider({
    responsive: [
      {
        breakpoint: 899,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4,
        }
      }
    ]
  });

  // Mock Content Start - UX-18974
  $('.js-carousel-search').slickSlider({
    slidesToShow: 7,
    slidesToScroll: 7,
    dots: true,
    responsive: [
      {
        breakpoint: 899,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4,
        }
      }
    ]
  });
  // Mock Content End - UX-18974
  $('.js-carousel-pw').slickSlider({
    slidesToShow: 4,
    slidesToScroll: 4,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        }
      },
      {
        breakpoint: 822,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 2,
        }
      }
    ]
  });
  $('.js-carousel--top-designers').slickSlider({
    slidesToShow: 6,
    slidesToScroll: 4,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4,
        }
      },
    ]
  });
  $('.js-carousel-shops').slickSlider({
    slidesToShow: 4,
    slidesToScroll: 4,
    lazyLoad: 'progressive',
    responsive: [
      {
        breakpoint: 822,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        }
      }
    ],
  });

  $('.js-carousel--full').slickSlider({
      dots: true,
      customPaging,
      dotsClass: "image-carousel__dots",
      appendDots: $(".image-carousel__dots-container"),
  })

  $('.js-carousel--centered').slickSlider({
    dots: true,
    customPaging,
    dotsClass: "image-carousel__dots",
    appendDots: $(".image-carousel__dots-container--centered"),
  });

  $('.js-carousel--centered--ab').slickSlider({
    dots: true,
    customPaging,
    dotsClass: "image-carousel__dots",
    appendDots: $(".image-carousel__dots-container--centered"),
    slidesToShow: 8,
    slidesToScroll: 8,
    responsive: [
      {
        breakpoint: 1027,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 5,
        }
      }
    ]
  });

  $('.js-hot-list-bs').breakpointLayoutSwitch({
    dots: true,
    customPaging,
    slidesToShow: 3.2,
    slidesToScroll: 3,
  })


  $('.js-foundation-flats').each(function () {
    const $foundationFlats = $(this);
    const $foundationFlatsDots = $foundationFlats.find(".carousel__dots-container");
    $foundationFlats.slickSlider({
      dots: true,
      customPaging,
      slidesToShow: 4,
      slidesToScroll: 4,
      dotsClass: "carousel__dots",
      appendDots: $foundationFlatsDots,
      responsive: [
        {
          breakpoint: 1025,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
          }
        }
      ]
    });
  });

  $('.js-carousel--gwp .js-carousel__track').gwpResponsiveSlider();
  $('.js-carousel--gwp').slickSlider({
    responsive: [
      {
        breakpoint: 1027,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4,
        }
      },
    ]
  });
    //Acts as a thumbnail navigation for PDP main image carousel.
    $('.js-primary-nav > .pdp__pager-thumb').on('click mouseover', function(e) {
      e.preventDefault();
      $('.js-slides-slick').slick('slickGoTo',$(this).index(), true);
    })


  $('.js-plp-bottom-carousel').slickSlider({
    slidesToShow: 4,
    slidesToScroll: 4,
    accessibility: true,
    nextArrow: ".js-carousel__next",
    prevArrow: ".js-carousel__prev",
  });

  $('.js-similar-carousel').slickSlider({
    slidesToShow: 4,
    slidesToScroll: 4,
  });

  $('.js-beauty-feature').slickSlider({
    slidesToShow: 1,
    slidesToScroll: 1,
    customPaging,
    dots: true,
    dotsClass: "image-carousel__dots",
    appendDots: $(".image-carousel__dots-container"),
  });

  $('.order-tracking-ctl .js-carousel-ctl').slickSlider({ //  order-tracking/returns page UX-11481 Mocks
    slidesToScroll: 5,
    dots: true,
    dotsClass: "ctl-carousel__dots",
    appendDots: $(".ctl-carousel__dots-container"),
  });

  $('.js-carousel-si').each(function () { //order-tracking/returns page UX-11481 Mocks
    var $carouselSI = $(this);
    $carouselSI.slickSlider({
      slidesToShow: 5,
      slidesToScroll: 5
    });
  });

  // UX-17870
  $('.js-order-tabs').tabs({
    tab: '.tab__link',
    tabContent: '.tab__content',
    tabContentActive: 'tab__content--active',
    tabActive: 'tab__link--active',
  })

  $('.js-carousel-beauty').slickSlider({
    slidesToShow: 4,
    slidesToScroll: 4,
  });

  $('.js-carousel-stylewith').slickSlider({
    slidesToShow: 3,
    slidesToScroll: 3,
    speed: 200,
  });

  $('.js-carousel-beauty-edit').slickSlider({
    infinite: true,
    slidesToShow: 1,
    dots: true,
    dotsClass: "slick-dots",
  });

  $('.js-carousel-bridesmaid-style').slickSlider({
    slidesToShow: 2,
    slidesToScroll: 2,
    showStatus: true,
    responsive: [
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      }
    ]
  });

  $('.js-carousel-single-product').slickSlider({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    accessibility: true,
    nextArrow: ".js-carousel__nav-next-single",
    prevArrow: ".js-carousel__nav-prev-single",
  });

  $('.js-carousel-qv-ctl').slickSlider({
    slidesToShow: 4,
    slidesToScroll: 4,
    nextArrow: ".js-carousel__nav-next-qv-ctl",
    prevArrow: ".js-carousel__nav-prev-qv-ctl",
  });

  $('.js-gc-carousel').slickSlider({
    slidesToShow: 5, // centerMode must have slidesToShow set to an odd number
    slidesToScroll: 1,
    arrows: true,
    infinite: false,
    accessibility: false,
    focusOnSelect: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3, // centerMode must have slidesToShow set to an odd number
        }
      },
    ]
  });


  // Global Banner slider
  // const bannerSlideshow = $('.js-slideshow');
  $('.js-slideshow').each(function () {
    var $bannerSlideshow = $(this);
    const language = $('html').attr('lang');
    let rtlBool = language === "ar";
    if ($bannerSlideshow.children('.banner--slider-list__item').length > 1) {
      $bannerSlideshow.slick({
        autoplay: true,
        autoplaySpeed: 6000,
        prevArrow: $bannerSlideshow.siblings('.banner__slick-prev'),
        nextArrow: $bannerSlideshow.siblings('.banner__slick-next'),
        rtl: rtlBool
      });
      $('.banner__slick-next, .banner__slick-prev').on('click', () => {
        $bannerSlideshow.slick('slickPause');
      });
    } else {
      $('.banner__slick-next, .banner__slick-prev').hide();
      $('.banner--slider-list').show();
    }
  });

  $('.js-carousel-ctl-stylitics').slickSlider({
    slidesToShow: 2,
    slidesToScroll: 2,
    infinite: false
  });

  $('.js-carousel-ctl-stylitics--extended').slickSlider({
    infinite: false,
    dotsClass: "image-carousel__dots",
    dots: true,
    customPaging,
    appendDots: $(".image-carousel__dots-stylitics"),
  });

  function carouselLwlImages($carouselName) {
    var countImage = $($carouselName + ' .slick-list').find(".slick-active").length
    $($carouselName + ' .slide-image-count').each(function () {
      $(this).append(countImage);
    });
  }

  window.slickSliderATBCTL = function () {
    $('.js-carousel-ctl-atb').slickSlider({
      slidesToShow: 3,
      slidesToScroll: 3,
      infinite: false,
    });
  };

  window.slickSliderLooksWeLoveBig = function () {
    $('.js-carousel__lwl').each(function () {
      var $carousel = $(this);

      $carousel.slickSlider({
        dots: true,
        customPaging,
        lazyLoad: 'progressive',
        dotsClass: "image-carousel__dots",
        appendDots: $(".image-carousel__dots-container-lwl"),
        infinite: true,
        slidesToShow: 4,
        slidesToScroll: 4, // this number ties with custom-pages.js to get total of dots
      });

      $carousel.on('breakpoint', function () {
        carouselLwlImages();
      });
      $carousel.keydown(function (e) {
        // Move the focus to the current slide if user is using the
        // left and right arrow keys
        if (e.keyCode == 37 || e.keyCode == 39) {
          e.preventDefault();
          // Set focus after slick has moved position
          $carousel.on('setPosition', function () {
            $carousel.find('.slick-current a').focus();
            $carousel.off('setPosition');
          });
        }
      });
    });
  }

  window.slickSliderLooksWeLoveBig();

  window.slickSliderLooksWeLoveSmall = function () {
    $('.js-lwl-carousel').slickSlider({
      dots: true,
      customPaging,
      lazyLoad: 'progressive',
      dotsClass: "image-carousel__dots",
      appendDots: $(".image-carousel__dots-container"),
      infinite: true,
      slidesToShow: 3,
      slidesToScroll: 3, // this number ties with custom-pages.js to get total of dots
    });
  }

  $('.js-shop-trends').slickSlider({
    lazyLoad: 'ondemand',
    slidesToShow: 5,
    slidesToScroll: 1,
  })

  window.slickSliderLooksWeLoveSmall();

  carouselLwlImages('.js-carousel__lwl');
  carouselLwlImages('.js-lwl-carousel');

  $('.js-carousel-fit-videos').slickSlider({
    slidesToShow: 6,
    slidesToScroll: 6,
    infinite: true,
    centerPadding: '0px',
    responsive: [
        {
            breakpoint: 1024,
            settings: {
                slidesToScroll: 4,
                slidesToShow: 4,
            }
        }
    ]
  });

  $('.js-rating-scale').ratingScale({
    titleSelector: '.form-section__title',
  });

  // product zoom pdp
  // $('body').productZoom();

  // input masking
  if ($('.js-mask-tel-us').length) {
    $('.js-mask-tel-us').mask('+1(000) 000-0000');
  }
  if ($('.js-mask-mx').length) {
    $('.js-mask-mx').mask('+52#000000000');
  }

  $('.js-mask-date').maskDate();

  window.Keyboard = Keyboard;
  window.throttle = throttle;
  $('.js-fixed-header').fixedHeader();
  $(window).scroll(function () {
    var fixedHeaderHeight = $('.js-fixed-header.is-fixed').height();
    var scroll = $(window).scrollTop();
    if (scroll > 0) {
      $(".js-hotlist-ads").addClass("is-fixed");
      $(".js-hotlist-ads").css('margin-top', fixedHeaderHeight);
    } else {
      $(".js-hotlist-ads").removeClass("is-fixed");
      $(".js-hotlist-ads").css('margin-top', 0);
    }
  });
  $('.js-dropdown').dropdown();
  $('.js-sign-out').on('click', function (e) {
    e.preventDefault();
    signOut();
  })
  $('.js-modal').modal();
  $.modal.a11y();
  $('.js-enterable').enterable();

  $('.js-sticky-video__container').stickyVideo();

  $('.js-guest-row').incrementCount();

  $('.js-toggle-reveal').toggleReveal();
  $('.js-toggle-reveal--ipad').toggleReveal();

  $(".js-accordion").accordion();

  $('.js-countdown').countdown();

  $('[data-sticky-scroll]').stickyScroll();

  $(".dropdown.dropdown--center").dropdownEnter();

  $(".fixed-corner").fixedCorner();
  $('.back-to-top').scrollToTop();
  $('.js-tabs').tabs();

  $('.js-faqs-tabs').tabs({
    tabActive : 'action-button--active',
    tabToggleOff: true,
  })

  $('.product-swatches--collapse').productSwatches();
  $('.js-double-tap-main .js-dropdown').doubleTapToGo();
  $('.js-ab-controls').abControls(); // Ab Testing Controls for previewing on testing servers
  $('.js-impressions-controls').impressionsControls();
  $('.js-voyages-package').each(function () {
    const $voyagesSelf = $(this);
    const $voyagersSlideshow = $voyagesSelf.find('.js-voyagers-slideshow');
    const $voyagersPrev = $voyagesSelf.find('.js-voyages-slideshow-prev');
    const $voyagersNext = $voyagesSelf.find('.js-voyages-slideshow-next');
    $voyagersSlideshow.slick({
      lazyLoad: 'ondemand',
      prevArrow: $voyagersPrev,
      nextArrow: $voyagersNext,
      dots: true,
    });
  });

  $('.js-product-filter-active-button').productFilterActiveButton({
    mountEl: '#filters-container',
    layoutType: 'inline'
  });

  $('.js-lazy-image').lazy({
    bind: 'event',
    effect: 'fadeIn',
    effectTime: 200,
    threshold: 500,
    throttle: 0
  });

  $('.js-stl-modal').shopTheLook();

  $('.js-floating-video-button').floatingVideo({hideMute:true});

  //MOCK TEST JS FOR FAVORTING DESIGNERS UX-18624
  $('.js-favorite-designer').on('click', function() {
    $(this).toggleClass('favorite-button--heart-active');
  });

  $('.js-placeholder-switch-text').responsivePlaceholder();

  $('.js-carousel--banner').slickSlider({
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: false,
    dots: false,
    infinite: true,
  });
});



// WEBPACK FOOTER //
// ./styleguide/src/assets/modules/modules.js